import gsap from 'gsap';
import { asyncAjaxCall, validateEmail } from './utils';
import { InnerLoader } from './Loader';
import { loaderClass, toastInstance, ticketsClass } from './main';

class Forms {
	constructor(form) {
		this.form = form;

		this.formELements = this.form.querySelectorAll('.form--element');
		this.submitButton = this.form.querySelector('.submit--form');
		this.action = this.form.querySelector('input[name="form-action"]').value;

		this.loaderClass = loaderClass
		this.toastsFactory = toastInstance
		this.ticketsClass = ticketsClass

		this.init()
	}
	init() {
		
		this.loaderClass = loaderClass

		let that = this;

		this.submitButton.addEventListener('click', () => {
			let action = this.form.querySelector('input[name="form-action"]').value
			
			if(action != 'generic_search_form'){
				this.checkErrors().then((data) => {
					if(this.form.classList.contains('with-inner-loader')) this.innerLoader(true)
					this.loaderClass.open()
					/* if(this.form.hasAttribute('id')){
						let iubendaData = {}
						Object.entries(data).forEach(([key, value]) => {
							if(value.iubendaRef){
								iubendaData = {...iubendaData, [value.iubendaRef]: key};
							}
						})

						this.iubendaConsentDB(this.form.getAttribute('id'), iubendaData);
					} */
					this.sendForm(data, action)
				})
			}
		})

		this.form.addEventListener('keypress', (e) => {
			if (e.keyCode === 13) {
				let action = this.form.querySelector('input[name="form-action"]').value
				if(action != 'generic_search_form'){
					this.checkErrors().then((data) => {
						if(this.form.classList.contains('with-inner-loader')) this.innerLoader(true)
						if(action != 'sales_modal' && action != 'parts_modal' && action != 'service_modal') this.loaderClass.open()
						if(this.form.hasAttribute('id')){
							let iubendaData = {}
							Object.entries(data).forEach(([key, value]) => {
								if(value.iubendaRef){
									iubendaData = {...iubendaData, [value.iubendaRef]: key};
								}
							})

							this.iubendaConsentDB(this.form.getAttribute('id'), iubendaData);
						}
						this.sendForm(data, action)
					})
				}
			}
		})

		this.form.querySelectorAll('.toggle-password').forEach((el) => {
			this.togglePasswordShow(el)
		})

		this.form.querySelectorAll('input[type="file"]').forEach((fileInput) => {
			const container = fileInput.closest('.file-item');
			const fake = container.querySelector('.fake-input');

			const updateFake = () => {
				const names = Array.from(fileInput.files || []).map(f => f.name);
				const text = names.length ? names.join(', ') : ''; // oppure '\n' per andar a capo
				if ('value' in fake) {
				fake.value = text;       // se è <input> / <textarea>
				} else {
				fake.textContent = text; // se è un <div>
				}
			};

			fileInput.addEventListener('change', updateFake);

			fake.addEventListener('click', () => {
				if ('value' in fake) {
					fake.value = '';
				} else {
					fake.textContent = '';
				}
				fileInput.value = '';
				fileInput.click();
			});

			if (fileInput.files && fileInput.files.length) {
				updateFake();
			}

			/* file.addEventListener('change', () => {
				if (file.files.length > 0) {
					file.closest('.file-item').querySelector('.fake-input').value = file.files[0].name
				}else{
					file.closest('.file-item').querySelector('.fake-input').value = ''
				}
			})
			file.closest('.file-item').querySelector('.fake-input').addEventListener('click', () => {
				file.closest('.file-item').querySelector('.fake-input').value = ''
				file.click()
			}) */
		})

		Object.values(this.formELements).filter((el) => el.classList.contains('select-item')).forEach((item) => {
			this.toggleSelect(item)
			this.getSelectValue(item)
			if(item.classList.contains('select-country-item'))this.searchOnSelect(item)

			document.addEventListener('click', (e) => {
				if(!item.contains(e.target)){
					if(!item.classList.contains('inactive')){
						let select = item.querySelector('.custom-select');
						if(select.classList.contains('open')){
							select.classList.remove('open')
						}
					}
				}
			})
		})
		
	}
	innerLoader(show){
		if(show){
			gsap.to(this.form.querySelector('.form-inner-loader'), { duration: 0.3, autoAlpha: 1, ease: 'power4.inOut' })
		}else{
			gsap.to(this.form.querySelector('.form-inner-loader'), { duration: 0.3, autoAlpha: 0, ease: 'power4.inOut' })
		}
	}
	async sendForm(data, action){
		let hasFilledFile = false;
		
		hasFilledFile = Object.values(data).some(field => {
			return field.type === "file" && field.value && field.value.length > 0;
		});

		let res;
		if(!this.form.classList.contains('form--with-upload') || !hasFilledFile){
			res = await asyncAjaxCall(action, { data })
			this.manageResults(res, action)
		}else{
			var formData = new FormData();
			formData.append("action", 'upload_file');

			if(data['folder']){
				formData.append("folder", data['folder'].value);
			}

			Object.values(data)
				.filter((el) => el.type == 'file')
				.forEach((input) => {
					const files = input.value || [];
					Array.from(files).forEach((file) => {
						formData.append('document[]', file, file.name);
					});
				})
			try {
				res = await asyncAjaxCall('upload_file', formData, (p) => {})
				const payload = res.data.data || {};
				if (res.data.success) {
					
					const uploaded = Array.isArray(payload.uploaded)
						? payload.uploaded
						: [{ saved_name: payload.file, url: payload.url }];

					const filesNames = uploaded.map(f => f.saved_name);
					const filesUrls  = uploaded.map(f => f.url).filter(Boolean);
					const filesPaths  = uploaded.map(f => f.path).filter(Boolean);

					const dataWithUploads = {
						...data,
						'uploaded-files': filesNames,
						'uploaded-files-urls': filesUrls,
						'uploaded-files-paths': filesPaths,
					};

					const res2 = await asyncAjaxCall(action, { data: dataWithUploads });
					this.manageResults(res2, action);
				} else {
					const msg = payload.message || res.data.message || 'Upload error';
					this.toastsFactory.createToast({ type: "error", message: msg, duration: 5000 });
				}
			} catch (error) {
				//this.loaderClass?.close?.();
    			//this.toastsFactory.createToast({ type: "error", message: 'Upload fallito. Riprova.', duration: 5000 });
			}			
		}
	}
	checkErrors() { 
		return new Promise((resolve) => {

			let successfullCheck = true;
			let data = {}

			this.formELements.forEach((el) => el.classList.remove('item-with-error'))
			this.formELements.forEach((el) => this.updateOnType(el))

			Object.values(this.formELements).filter((el) => el.classList.contains('check-if-empty')).forEach((item) => {
				if(item.classList.contains('textarea-item')){
					let value = item.querySelector('textarea').value;

					if(value == ''){
						successfullCheck = false
						item.classList.add('item-with-error')
					}
				}else{
					let value = item.querySelector('input').value;

					if(value == ''){
						successfullCheck = false
						item.classList.add('item-with-error')
					}
				}
				
			})

			Object.values(this.formELements).filter((el) => el.classList.contains('check-if-selected')).forEach((item) => {
				let value = item.querySelector('.real').value;

				if(value == ''){
					successfullCheck = false
					item.classList.add('item-with-error')
				}
			})

			Object.values(this.formELements).filter((el) => el.classList.contains('check-if-email')).forEach((item) => {
				let value = item.querySelector('input').value;
				
				if(!validateEmail(value)){
					successfullCheck = false
					item.classList.add('item-with-error')
				}
			})

			Object.values(this.formELements).filter((el) => el.classList.contains('check-if-checked')).forEach((item) => {
				let value = item.querySelector('input').value;
				
				if(!item.querySelector('input').checked){
					successfullCheck = false
					item.classList.add('item-with-error')
				}
			})

			Object.values(this.formELements).filter((el) => el.classList.contains('check-recovery-code')).forEach((item) => {
				let value = item.querySelector('.real-value').value;
				
				if(value == '' || value.length < 6){
					successfullCheck = false
					item.classList.add('item-with-error')
				}
			})

			Object.values(this.formELements).filter((el) => el.classList.contains('wooselect-item')).forEach((item) => {
				let paragraph = item.querySelector('.form-row');

				if(paragraph.classList.contains('validate-required')){
					let selectVal = paragraph.querySelector('.woocommerce-input-wrapper select').value

					if(selectVal == '') {
						successfullCheck = false
						item.classList.add('item-with-error')
					}
				}
			})

			Object.values(this.formELements).filter((el) => el.classList.contains('check-if-checkbox-select')).forEach((item) => {
				let checkboxes = item.querySelectorAll('input[type="checkbox"]');
				const isChecked = [...checkboxes].some(checkbox => checkbox.checked);
				
				if(!isChecked){
					successfullCheck = false
					item.classList.add('item-with-error')
				}
			})
			
			if(successfullCheck) {
				Object.values(this.formELements).filter((el) => !el.classList.contains('privacy-checkbox')).forEach((item) => {
					let label, value, type;
					if(item.classList.contains('hidden-item')){
						label = item.querySelector('input').getAttribute('name');
						value = item.querySelector('input').value.trim();
						type = 'hidden';
					}
					if(item.classList.contains('wooselect-item')){
						if(item.querySelector('.form-row .woocommerce-input-wrapper select')){
							label = item.querySelector('.form-row .woocommerce-input-wrapper select').getAttribute('name');
							value = item.querySelector('.form-row .woocommerce-input-wrapper select').value;
							type = 'wooselect';
						}else{
							label = item.querySelector('.form-row .woocommerce-input-wrapper input').getAttribute('name');
							value = item.querySelector('.form-row .woocommerce-input-wrapper input').value;
							type = 'wooselect';
						}
						
					}
					if(item.classList.contains('text-item')){
						label = item.querySelector('input').getAttribute('name');
						value = item.querySelector('input').value.trim();
						type = 'text';
					}
					if (item.classList.contains('file-item')) {
						const input = item.querySelector('input[type="file"]');
						label = input.name;
						type  = 'file';

						const files = input.files ? Array.from(input.files) : [];

						value = files;
					}
					if(item.classList.contains('number-item')){
						label = item.querySelector('input').getAttribute('name');
						value = item.querySelector('input').value.trim();
						type = 'number';
					}
					if(item.classList.contains('password-item')){
						label = item.querySelector('input').getAttribute('name');
						value = item.querySelector('input').value.trim();
						type = 'password';
					}
					if(item.classList.contains('textarea-item')){
						label = item.querySelector('textarea').getAttribute('name');
						value = item.querySelector('textarea').value.trim();
						type = 'text';
					}
					if(item.classList.contains('checkbox-item')){
						label = item.querySelector('input').getAttribute('name');
						value = item.querySelector('input[type="checkbox"]').checked ? true : false;
						type = 'checkbox';
					}
					if(item.classList.contains('newsletter-item')){
						label = item.querySelector('input').getAttribute('name');
						value = item.querySelector('input[type="checkbox"]').checked ? true : false;
						type = 'newsletter';
					}
					if(item.classList.contains('one-time-code-item')){
						label = item.querySelector('.real-value').getAttribute('name');
						value = item.querySelector('.real-value').value;
						type = 'one-time-code';
					}
					if(item.classList.contains('select-item')){
						label = item.querySelector('.real').getAttribute('name');
						value = item.querySelector('.real').value;
						type = 'select';
					}
					if(item.classList.contains('checkbox-multiple-item')){
						let checkboxes = item.querySelectorAll('input[type="checkbox"]');
						label = item.querySelector('input').getAttribute('name');
						value = [...checkboxes].filter(checkbox => checkbox.checked).map(checkbox => checkbox.value);
						type = 'checkbox-multiple';
					}

					data = { ...data, [label]: {value, type} }
				})
				resolve(data)
			}else{
				this.toastsFactory.createToast({
					type: "error",
					message: generic_error_messages.form.empty_field,
					duration: 5000
				});
				//setTimeout(() => {
					window.addEventListener('ToastClosed', () => {
						Object.values(this.formELements).forEach((el) => {
							if(el.classList.contains('item-with-error')){
								el.classList.remove('item-with-error')
							}
						})
					})
					
				//}, 5000)
			}
		})
	}
	updateOnType(item) {
		item.addEventListener('keyup', () => {
			if(item.classList.contains('item-with-error')){
				item.classList.remove('item-with-error')
			}
		})
	}
	iubendaConsentDB(formId, formData) {
		_iub.cons_instructions.push(["load", {
			form: {
				selector: document.getElementById(formId),
				map: {
					subject: formData,
					preferences: {
						generic: "generic"
					}
				}
			},
			writeOnLocalStorage: false,
			consent: {
				legal_notices: [
					{
						identifier: "privacy_policy",
					},
					{
						identifier: 'cookie_policy',
					},
					{
						identifier: "terms",
					}
				],
			}
		}])
		_iub.cons.sendData();
	}
	togglePasswordShow(el) {
		let input = el.querySelector('input')
		el.querySelector('.toggle-password-btn').addEventListener('click', () => {
			if(input.getAttribute('type') == 'password'){
				input.setAttribute('type', 'text')
			}else{
				input.setAttribute('type', 'password')
			}
		})
	}
	toggleSelect(item){
		item.querySelector('.select-top').addEventListener('click', (e) => {
			const t = e.target;
			if (t.closest('input')) return; // evita doppio trigger da label→input
			if(!item.classList.contains('inactive')){
				let select = item.querySelector('.custom-select');
				if(select.classList.contains('open')){
					select.classList.remove('open')
				}else{
					select.classList.add('open')
				}
			}
		})
	}
	getSelectValue(item){
		let items = item.querySelectorAll('.select-bottom ul li')
		items.forEach((element) => {
			element.addEventListener('click', () => {
				let val = element.getAttribute('val');
				let label = element.querySelector('span').innerHTML;

				item.querySelector('.real').setAttribute('value', val)
				item.querySelector('.fake').setAttribute('value', label)
				item.querySelector('.custom-select').classList.remove('open')
			})
		})
	}
	searchOnSelect(item) {
		let input = item.querySelector('.search-select input')

		input.addEventListener('keyup', () => {
			let value = input.value.toLowerCase();
			let items = item.querySelectorAll('.select-bottom ul li');

			items.forEach((element) => {
				let label = element.getAttribute('label').toLowerCase();
				if (label.includes(value)) {
					element.style.display = 'block';
				} else {
					element.style.display = 'none';
				}
			});
		})
	}
	manageResults(result, action){
		if(action == 'tickets_booking'){
			this.loaderClass.close()
			if(result.data.code == 500){
				if(this.form.classList.contains('with-inner-loader')) this.innerLoader(false)
				this.toastsFactory.createToast({
					type: "error",
					message: result.data.message,
					duration: 8000
				});
			}else{
				this.resetFormFields()
				if(this.form.classList.contains('with-inner-loader')) this.innerLoader(false)
				if(this.form.classList.contains('close-ticket-on-success')) {
					console.log(this.ticketsClass)
					this.ticketsClass.close()
				}
				this.toastsFactory.createToast({
					type: "success",
					message: result.data.message,
					duration: 8000
				});
			}
		}
	}
	resetFormFields(){
		Object.values(this.formELements).filter((el) => el.classList.contains('text-item') || el.classList.contains('password-item') || el.classList.contains('number-item')).forEach((item) => {
			item.querySelector('input').value = ''
		})
		Object.values(this.formELements).filter((el) => el.classList.contains('privacy-checkbox')).forEach((item) => {
			item.querySelector('input').checked = false
		})
		Object.values(this.formELements).filter((el) => el.classList.contains('newsletter-item')).forEach((item) => {
			item.querySelector('input').checked = false
		})
		Object.values(this.formELements).filter((el) => el.classList.contains('textarea-item')).forEach((item) => {
			item.querySelector('textarea').value = ''
		})
		Object.values(this.formELements).filter((el) => el.classList.contains('one-time-code-item')).forEach((item) => {
			const inputs = item.querySelectorAll(".otp-input input");
			inputs.forEach((inp) => inp.value = '')
		})
		Object.values(this.formELements).filter((el) => el.classList.contains('select-item')).forEach((item) => {
			item.querySelector('.real').value = ''
			item.querySelector('.fake').value = ''
		})
		Object.values(this.formELements).filter((el) => el.classList.contains('file-item')).forEach((item) => {
			item.querySelector('input[type="file"]').value = ''
			item.querySelector('.fake-input').value = ''
		})
	}
}

export { Forms };